import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostImageInterface } from 'common/types/entities/BlogPostImageInterface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import {
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostImage(
  parentId: string,
  masterBlockId?: MasterBlockId,
): BlogPostImageInterface {
  return {
    id: generateId(),
    type: EntityTypeEnum.BlogPostImage,
    parentId: parentId,
    masterBlockId: masterBlockId,
    appearance: {
      desktop: true,
      mobile: true,
    },
    border: {
      radius: 3,
      width: 1,
      style: BorderStyleEnum.none,
    },
    margin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.BlogPostImage),
  }
}
